const data = {
  'Selected': 'Seleccionados: {0} de {1}',
  'Uploading files': 'Subiendo {0}% de {1}',
  'File size error': '{0} es demasiado grande, por favor suba ficheros menores a {1}',
  'Upload failed': '{0} no se pudo subir',
  'Per page': '{0} por página',
  'Folder': 'Carpeta',
  'Login failed, please try again': 'Inicio de sesión incorrecto, por favor pruebe de nuevo',
  'Already logged in': 'Ya había iniciado sesión.',
  'Please enter username and password': 'Por favor, escriba nombre de usuario y contraseña.',
  'Not Found': 'No encontrado',
  'Not Allowed': 'No permitido',
  'Please log in': 'Por favor, inicie sesión',
  'Unknown error': 'Error desconocido',
  'Add files': 'Añadir ficheros',
  'New': 'Nuevo',
  'New name': 'Nuevo nombre',
  'Username': 'Nombre de usuario',
  'Password': 'Contraseña',
  'Login': 'Iniciar sesión',
  'Logout': 'Salir',
  'Profile': 'Perfil',
  'No pagination': 'Sin paginación',
  'Time': 'Fecha',
  'Name': 'Nombre',
  'Size': 'Tamaño',
  'Home': 'Carpeta principal',
  'Copy': 'Copiar',
  'Move': 'Mover',
  'Rename': 'Renombrar',
  'Required': 'Por favor, rellene este campo',
  'Zip': 'Comprimir',
  'Batch Download': 'Descarga por lotes',
  'Unzip': 'Descomprimir',
  'Delete': 'Eliminar',
  'Download': 'Descargar',
  'Copy link': 'Copiar enlace',
  'Done': 'Hecho',
  'File': 'Archivo',
  'Drop files to upload': 'Soltar archivos para subir',
  'Close': 'Cerrar',
  'Select Folder': 'Seleccionar carpeta',
  'Users': 'Usuarios',
  'Files': 'Ficheros',
  'Role': 'Rol',
  'Cancel': 'Cancelar',
  'Paused': 'Pausado',
  'Confirm': 'Confirmar',
  'Create': 'Crear',
  'User': 'Usuario',
  'Admin': 'Administrador',
  'Save': 'Guardar',
  'Read': 'Leer',
  'Write': 'Escribir',
  'Upload': 'Subir',
  'Permissions': 'Permisos',
  'Homedir': 'Carpeta inicial',
  'Leave blank for no change': 'Dejar en blanco para no cambiar',
  'Are you sure you want to do this?': '¿Seguro que quiere hacer esto?',
  'Are you sure you want to allow access to everyone?': '¿Seguro que quiere permitir el acceso a todo el mundo?',
  'Are you sure you want to stop all uploads?': '¿Seguro que quiere parar todas las subidas?',
  'Something went wrong': 'Algo ha ido mal',
  'Invalid directory': 'Carpeta incorrecta',
  'This field is required': 'Este campo es obligatorio',
  'Username already taken': 'El nombre de usuario ya existe',
  'User not found': 'Usuario no encontrad',
  'Old password': 'Contraseña anterior',
  'New password': 'Nueva contraseña',
  'Wrong password': 'Contraseña incorrecta',
  'Updated': 'Actualizado',
  'Deleted': 'Eliminado',
  'Your file is ready': 'Su fichero está listo',
  'View': 'View',
}

export default data
